import src from './source';
import * as _ from './common';
import { getFieldValue } from './fieldUtil';
import { judgeIsNumber,convertFloatValue } from './inputUtil';

//公式运算入口
export const calculateFormula = (triInfo) =>{
	const { dataJson,fieldAttrMap,detailMap } = src.layoutStore;
	const formulaCfg = dataJson.formula || {};
    const changeDatas = {};
    triInfo.map(info =>{
        try{
			const cfg = formulaCfg[info.formulaKey];
			if(!cfg || !_.has(cfg,"destfield") || !_.has(cfg,"formulatxt") || !_.has(cfg,"cellrange"))
                return true;
            const destCell = cfg["destcell"];
            const destField = cfg["destfield"];
            const formulaTxt = _.trim(cfg["formulatxt"]).substring(1);
            //公式解析分如下几种情况
            if(destCell.indexOf("DETAIL_") === -1){		//赋值给主表字段
                let result = '';
                if((/DETAIL_\d+\./).test(formulaTxt)){	//取值字段包含明细表字段
                    const reg = /^(EXCEL_AVERAGE|EXCEL_MIN|EXCEL_MAX)\((\s*(MAIN|TAB_\d+|DETAIL_\d+)\.[A-Z]+\d+\s*(\,)?)+\)$/;
                    if(reg.test(formulaTxt)){			//求平均、最大、最小特殊处理(例：AVG(明细字段或主字段))
                        result = calculate_detail_special(formulaTxt);
                    }else{
                        result = calculate_detail_sum(formulaTxt);
                    }
                }else{									//取值字段全部为主表字段
                    result = calculate_single(formulaTxt, -1);
                }
				changeDatas[`field${destField}`] = {value:result};
            }else{										//赋值给明细字段
				const destTableMark = fieldAttrMap.get(destField).tableMark;
				const rowIndexStr = info.triRowMark === "all" ? getDetailAllRowIndexStr(destTableMark) : info.triRowMark.toString();
				!!rowIndexStr && rowIndexStr.split(",").map(rowIndex =>{
					const result = calculate_single(formulaTxt, rowIndex);
					changeDatas[`field${destField}_${rowIndex}`] = {value:result};
				});
            }
        }catch(ex){
			/* eslint no-console: 0 */
			if(window.console)  console.error("Formula calculate error: "+ex);
        }
    });
    return changeDatas;
}

//获取明细表全部行id拼接成串
const getDetailAllRowIndexStr = (detailMark) =>{
	const { detailMap } = src.layoutStore;
	return detailMap.has(detailMark) ? detailMap.get(detailMark).allRowIndexStr : "";
}

//单条/单行公式计算
const calculate_single = (formulaTxt, rowMark) =>{
    return evalFormual(replaceFormula(formulaTxt, rowMark));
}

//明细列求平均/最大赋值主字段，特殊公式处理
const calculate_detail_special = (formulaTxt) =>{
    return evalFormual(replaceFormula(formulaTxt, "all"));
}

//明细作为取值字段的公式，计算明细每一行公式结果，再合计赋值主字段
const calculate_detail_sum = (formulaTxt) =>{
	let sumResult = "";
	const detailMark = formulaTxt.match(/(DETAIL_\d+)/g)[0].toLowerCase();
	const allRowIndex = getDetailAllRowIndexStr(detailMark);
	!!allRowIndex && allRowIndex.split(",").map(rowIndex =>{
		try{
			const singleRowResult = evalFormual(replaceFormula(formulaTxt, rowIndex));
			sumResult = EXCEL_SUM(sumResult, singleRowResult);
		}catch(ev){}
	});
	return sumResult;
}

const evalFormual = (expression) =>{
	let result = "";
    try{
        result = eval(expression);
    }catch(e){
		/* eslint no-console: 0 */
		if(window.console)  console.error("evalFormual Appear Exception:"+expression);
    }
    return result.toString();
}

//替换公式，单元格标示替换成对应字段值
const replaceFormula = (formulaTxt, rowMark) =>{
    if(rowMark !== "all" && isNaN(rowMark))
		throw new Error("RowMark Parameter Illegal");
	const { cellInfo } = src.layoutStore;
	const fieldCellInfo = cellInfo.fieldCellInfo || {};
    const reg = /(MAIN|TAB_\d+|DETAIL_\d+)\.[A-Z]+\d+/g;
    formulaTxt.match(reg).map(cellAttr =>{
        let fieldValue = "";
        const fieldid = convertCellAttrToFieldid(fieldCellInfo, cellAttr);
        if(!!fieldid){      //单元格非字段情况作为空值处理
			const isDetail = cellAttr.indexOf("DETAIL_") > -1;
            const tableMark = isDetail ? cellAttr.split(".")[0].toLowerCase() : "main";
            if(isDetail && rowMark === "all"){      //求明细列最大等情况，需取明细所有行值参与计算
                const allRowIndex = getDetailAllRowIndexStr(tableMark);
				!!allRowIndex && allRowIndex.split(",").map((rowIndex,index) =>{
					if(index > 0)
						fieldValue += ",";
					fieldValue += getSingleFieldValue(fieldid, rowIndex, tableMark);
				});
            }else{
                fieldValue = getSingleFieldValue(fieldid, rowMark, tableMark);
            }
        }
        //表达式替换
		const reg1 = new RegExp(cellAttr+"(?!\\d)", "g");
		if(fieldValue.startsWith("-"))
			fieldValue = `(${fieldValue})`;
        formulaTxt = formulaTxt.replace(reg1, fieldValue);
    });
    return formulaTxt;
}

//获取单个字段值
const getSingleFieldValue = (fieldid, rowIndex, tableMark) =>{
	const { fieldAttrMap } = src.layoutStore;
	let fieldValue = getFieldValue(fieldid, rowIndex);
    const fieldAttr = fieldAttrMap.get(fieldid);
    if(fieldAttr.htmltype === 1 && fieldAttr.detailtype === 5)
        fieldValue = fieldValue.toString().replace(/,/g, "");
    //非数值结果作为字符串处理
    if(fieldValue === "" || !judgeIsNumber(fieldValue, true))
        fieldValue = "\""+fieldValue+"\"";
    return fieldValue;
}

//公式标示转换成单元格标示(例：DETAIL_1.C4------>detail_1_4_3)
const convertCellAttrToFieldid = (fieldCellInfo, cellAttr) =>{
    const symbol = cellAttr.split(".")[0].toLowerCase();
    const letter = cellAttr.split(".")[1];
    const rowid = parseInt(letter.match(/\d+$/)[0]) - 1;
    const colid = convertCharToInt(letter.match(/^[a-zA-Z]+/)[0]) -1;
	let fieldid = "";
	_.forIn(fieldCellInfo, (v,k) =>{
		if(v.rowid === rowid && v.colid === colid && v.symbol === symbol){
			fieldid = k;
			return false;
		}
	});
    return fieldid;
}

//字母转数字(例：AB---->27)
const convertCharToInt = (value) =>{
    let rtn = 0;
    let powIndex = 0;
    for (let i = value.length - 1; i >= 0; i--){
        let tmpInt = value[i].charCodeAt() - 64;
        rtn += Math.pow(26, powIndex) * tmpInt;
        powIndex++;           
    }
    return rtn;
}


//是否是纯数字、整数
function isInt(str){
	var reg = /^[0-9]+$/;
	return reg.test(str);
}

//是否是数值类型


//JS parseFloat求和精度不一致问题解决
function rewrite_add(arg1,arg2){
	var r1=0,r2=0; 
	try{
		r1=arg1.toString().split(".")[1].length;
	}catch(e){}
	try{
		r2=arg2.toString().split(".")[1].length;
	}catch(e){}
	var m=Math.pow(10,Math.max(r1,r2)); 
	return (arg1*m+arg2*m)/m; 
}

//求和
function EXCEL_SUM(){
	var result = "";
	for(var i=0;i<arguments.length;i++){
		var par = arguments[i];
		if(!isNaN(parseFloat(par))){
			if(result === "")
				result = 0;
			result = rewrite_add(result,par);
		}
	}
	return result;
}

//求平均数
function EXCEL_AVERAGE(){
	var count = 0;
	var sumVal = 0;
	for(var i=0;i<arguments.length;i++){
		var par = arguments[i];
		if(!isNaN(parseFloat(par))){
			//sumVal += parseFloat(par);
			sumVal = rewrite_add(sumVal,par);
			count++;
		}
	}
	if(count>0){
		return parseFloat(sumVal/count);
	}else{
		throw new Error("EXCEL_AVERAGE divisor is zero");
	}
}
//求绝对值
function EXCEL_ABS(){
	if(arguments.length==1){
		var par = arguments[0];
		if(!isNaN(parseFloat(par))){
			var result = Math.abs(parseFloat(par));
			return result;
		}else{
			throw new Error("EXCEL_ABS arguments value is not a number");
		}
	}else{
		throw new Error("EXCEL_ABS arguments number must equal one");
	}
}
//精度计算
function EXCEL_ROUND(){
	if(arguments.length==2){
		var par1 = arguments[0];
		var par2 = arguments[1];
		if(!isNaN(parseFloat(par1))){
			par1 = parseFloat(par1);
		}else{
			throw new Error("EXCEL_ROUND first argument value is not a number");
		}
		if(isInt(par2)){
			par2 = parseInt(par2);
		}else{
			throw new Error("EXCEL_ROUND second argument value is not a int");
		}
		return convertFloatValue(par1, par2);
	}else{
		throw new Error("EXCEL_ROUND arguments number must equal two");
	}
}
//条件判断
function EXCEL_IF(){
	if(arguments.length==3){
		if(eval(arguments[0])){
			return arguments[1];
		}else{
			return arguments[2];
		}
	}else{
		throw new Error("EXCEL_IF arguments number must equal three");
	}
}
//求最大值
function EXCEL_MAX(){
	var result;
	for(var i=0;i<arguments.length;i++){
		var par = arguments[i];
		if(!isNaN(parseFloat(par))){
			if(result==null){
				result = parseFloat(par);
			}else{
				if(parseFloat(par)>result)	
					result = parseFloat(par);
			}
		}
	}
	if(result!=null){
		return result;
	}else{
		throw new Error("EXCEL_MAX arguments value must contain a number");
	}
}
//求最小值
function EXCEL_MIN(){
	var result;
	for(var i=0;i<arguments.length;i++){
		var par = arguments[i];
		if(!isNaN(parseFloat(par))){
			if(result==null){
				result = parseFloat(par);
			}else{
				if(parseFloat(par)<result)	
					result = parseFloat(par);
			}
		}
	}
	if(result!=null){
		return result;
	}else{
		throw new Error("EXCEL_MIN arguments value must contain a number");
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/formula.js